<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2 {{ $t('h2') }}

    form-forgot-password
    router-link.link-btn.enter-number(v-bind:to={'name': 'enter-number'}) {{ $t('enter-number') }}  
</template>

<script>
import formForgotPassword from '../form-enter-forgot-code/component';

export default {
  components: {
    formForgotPassword,
  },
};
</script>

<style scoped>
.enter-number {
  margin-top: 16px;
}
</style>
